import React, { useState } from "react";
import Masonry from "react-masonry-css";
import Lightbox from "yet-another-react-lightbox";
import "yet-another-react-lightbox/styles.css";
import styled from "styled-components";
// Importamos el plugin de thumbnails y su CSS
import Thumbnails from "yet-another-react-lightbox/plugins/thumbnails";
import "yet-another-react-lightbox/plugins/thumbnails.css";


const masonryGridStyle = {
  display: "flex",
  marginLeft: "-30px",
  width: "auto",
};

// Componente para las columnas dentro de la rejilla
export const MasonryColumn = styled.div`
  padding-left: 30px;
  background-clip: padding-box;
`;

// Componente para cada imagen
export const ImageItem = styled.div`
  margin-bottom: 30px;
`;

// Componente para la imagen dentro de ImageItem
export const Image = styled.img`
  width: 100%;
  height: auto;
  border-radius: 5px;
  max-height: 400px; /* Altura específica de las imágenes */
  object-fit: cover; /* Para que las imágenes se ajusten sin perder proporción */
`;

const imagesdata = [
  { url: "/img/portfolio/img1.webp" },
  { url: "/img/portfolio/img2.webp" },
  { url: "/img/portfolio/img3.webp" },
  { url: "/img/portfolio/img4.webp" },
  { url: "/img/portfolio/img5.webp" },
  { url: "/img/portfolio/img6.webp" },
  { url: "/img/portfolio/img7.webp" },
  { url: "/img/portfolio/img8.webp" },
  { url: "/img/portfolio/img9.webp" },
  { url: "/img/portfolio/img10.webp" },
  { url: "/img/portfolio/img11.webp" },
  { url: "/img/portfolio/img12.webp" },
  { url: "/img/portfolio/img13.webp" },
  { url: "/img/portfolio/img14.webp" },
  { url: "/img/portfolio/img15.webp" },
  { url: "/img/portfolio/img16.webp" },
  { url: "/img/portfolio/img17.webp" },
  { url: "/img/portfolio/img18.webp" },
  { url: "/img/portfolio/img19.webp" },
  { url: "/img/portfolio/img20.webp" },
  { url: "/img/portfolio/img21.webp" },
  { url: "/img/portfolio/img22.webp" },
  { url: "/img/portfolio/img23.webp" },
  { url: "/img/portfolio/img24.webp" },
  { url: "/img/portfolio/img25.webp" },
  { url: "/img/portfolio/img26.webp" },
  { url: "/img/portfolio/img27.webp" },
  { url: "/img/portfolio/img28.webp" },
  { url: "/img/portfolio/img29.webp" },
  { url: "/img/portfolio/img30.webp" },
  { url: "/img/portfolio/img31.webp" },
  { url: "/img/portfolio/img32.webp" },
  { url: "/img/portfolio/img33.webp" },
  { url: "/img/portfolio/img34.webp" },
  { url: "/img/portfolio/img35.webp" },
  { url: "/img/portfolio/img36.webp" },
  { url: "/img/portfolio/img37.webp" },
  { url: "/img/portfolio/img38.webp" },
  { url: "/img/portfolio/img39.webp" },
  { url: "/img/portfolio/img40.webp" },
  { url: "/img/portfolio/img41.webp" },
  { url: "/img/portfolio/img42.webp" },
  { url: "/img/portfolio/img43.webp" },
  { url: "/img/portfolio/img44.webp" },
  { url: "/img/portfolio/img45.webp" },
];

const itemsPerPage = 6; // Número de elementos por página
const totalItems = imagesdata.length; // Total de elementos disponibles
const totalPages = Math.ceil(totalItems / itemsPerPage); // Total de páginas necesarias

const GalleryMansory = () => {
  const [index, setIndex] = useState(-1);
  
  const [open, setOpen] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);

  // Calcular el índice inicial y final de los elementos que deben mostrarse en la página actual
  const startIndex = (currentPage - 1) * itemsPerPage;
  const endIndex = startIndex + itemsPerPage;

   // Seleccionar solo los elementos de la página actual
   const currentItems = imagesdata.slice(startIndex, endIndex);

  // Convert array to JSX items
  const items = currentItems.map((item, i) => (
    <MasonryColumn key={i}>
      <ImageItem
        onClick={() => {
          setIndex(i);
          setOpen(true);
        }}
      >
        <Image src={item.url} alt={`image-${i+1}`} />
      </ImageItem>
    </MasonryColumn>
  ));

  // Object for responsive breakpoints
  const breakpointColumnsObj = {
    default: 3, // Número de columnas por defecto
    1100: 2, // Para pantallas de 1100px o más, 2 columnas
    700: 1, // Para pantallas de 700px o más, 1 columna
  };

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  return (
    <>
      <Masonry
        breakpointCols={breakpointColumnsObj} // Usar el objeto de breakpoints
        className="my-masonry-grid"
        columnClassName="my-masonry-grid_column"
        style={masonryGridStyle}
      >
        {items} {/* Lista de imágenes */}
      </Masonry>
   <Lightbox
        slides={imagesdata.map((img, i) => ({ src: img.url }))}
        index={index}
        open={open}
        close={() => setOpen(false)}
        plugins={[Thumbnails]}
      />
      <div className="pagination">
        {/* Paginación de botones */}
        <button 
          onClick={() => handlePageChange(currentPage - 1)} 
          disabled={currentPage === 1}
        >
          Anterior
        </button>

        {/* Mostrar las páginas */}
        {[...Array(totalPages)].map((_, index) => (
          <button 
            key={index} 
            onClick={() => handlePageChange(index + 1)} 
            className={currentPage === index + 1 ? 'active' : ''}
          >
            {index + 1}
          </button>
        ))}

        <button 
          onClick={() => handlePageChange(currentPage + 1)} 
          disabled={currentPage === totalPages}
        >
          Siguiente
        </button>
      </div>
    </>
  );
};

export default GalleryMansory;
